import { PaginationType } from 'common';
import { AppRootStateType } from 'state/reducers';
import { TimeCodeType } from 'state/reducers/timeCodesReducer/types';

export const selectTimeCodes = (state: AppRootStateType): TimeCodeType[] =>
  state.timeCodes.timeCodes;
export const selectTimeCodesPagination = (state: AppRootStateType): PaginationType => ({
  page: state.timeCodes.page,
  count: state.timeCodes.count ?? 0,
});

export const selectTimeCodesIsLoading = (state: AppRootStateType): boolean =>
  state.timeCodes.isLoading;
